<template>
    <ChartBlock :data="data" v-if="isLoading" />
    <LoadingWrap v-else />
</template>

<script>
import { getDartData } from '@/api';
import ChartBlock from '@/components/ChartBlock.vue';
import LoadingWrap from '@/components/LoadingWrap.vue';

export default {
    components: {
        ChartBlock,
        LoadingWrap,
    },
    data() {
        return {
            isLoading: false,
            data: {
                unit: '%',
                stacked: true,
                step: 10,
                type: [
                    {
                        name: 'ROE (Annualized)',
                        type: 'line',
                        color: '#48c4c0',
                        data: [],
                    },
                    {
                        name: 'ROA (Annualized)',
                        type: 'line',
                        color: '#5f48c4',
                        data: [],
                    },
                ],
                years: [],
            },
        };
    },
    async mounted() {
        const {
            data: { KI },
        } = await getDartData();
        const modifyData = Object.keys(KI).reduce(
            (acc, key) => {
                Object.entries(KI[key]).forEach((entrie) => {
                    if (!acc.years.includes(entrie[0])) acc.years.push(entrie[0]);
                    if (!acc.type[key]) {
                        acc.type[key] = [+entrie[1]];
                    } else {
                        acc.type[key].push(+entrie[1]);
                    }
                });
                return acc;
            },
            {
                type: {},
                years: [],
            }
        );

        this.data.type[0].data = modifyData.type.roe; //ROE (Annualized)
        this.data.type[1].data = modifyData.type.roa; //ROA (Annualized)
        this.data.years = modifyData.years;

        this.isLoading = true;
    },
};
</script>

<style></style>
